import __request__ from "routing/request";
export function listBundles(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInstallationStatus(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/installation_status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function disableCurrentPacks(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/bundles/latest/disable_packs", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enableCurrentPacks(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/bundles/latest/enable_packs", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function filterPacks(query, category, tags, input_types, is_new, update_available, enabled, type, included_in_bundle, include_deps = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/latest/search_packs", null, { "query": query, "category": category, "tags": tags, "input_types": input_types, "is_new": is_new, "update_available": update_available, "enabled": enabled, "type": type, "included_in_bundle": included_in_bundle, "include_deps": include_deps }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function searchPacksPaginated(page = 1, per_page = 15, query, category, tags, input_types, is_new, update_available, enabled, type, included_in_bundle, include_deps = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/latest/search_packs_paginated", null, { "page": page, "per_page": per_page, "query": query, "category": category, "tags": tags, "input_types": input_types, "is_new": is_new, "update_available": update_available, "enabled": enabled, "type": type, "included_in_bundle": included_in_bundle, "include_deps": include_deps }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function searchPacksForTagPaginated(tag, page = 1, per_page = 15, query, category, tags, input_types, is_new, update_available, enabled, type, included_in_bundle, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.illuminate/bundles/latest/search_packs_paginated/${tag}`, null, { "page": page, "per_page": per_page, "query": query, "category": category, "tags": tags, "input_types": input_types, "is_new": is_new, "update_available": update_available, "enabled": enabled, "type": type, "included_in_bundle": included_in_bundle }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function latestSummary(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/latest/summary", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function packFilterOptions(request, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.illuminate/bundles/packs/filter_options", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function previousBundleExists(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/previous", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function enablePreviousBundle(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/bundles/previous/enable_bundle", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function restartProcessing(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/bundles/processing_restart", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStatus(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function upload(file, requestOptions) {
  const formData = new FormData();
  formData.append("file", file);
  return __request__("POST", "/plugins/org.graylog.plugins.illuminate/bundles/upload", formData, {}, {
    "Accept": ["text/plain"]
  }, requestOptions);
}
export function enableBundle(version, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.illuminate/bundles/${version}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(version, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.illuminate/bundles/${version}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
